firebird.controller('canvasBannerCtrl', [
    '$rootScope',
    '$scope',
    'logService',
    'localizationService',
    'storageService',
    'meetingService',
    function ($rootScope, $scope, logService, localizationService, storageService, meetingService) {
        var self = this;

        self.state = 'hide';
        self.header = '';
        self.content = '';
        self.buttonText = localizationService.translate('COMMON.DISMISS_TEXT');
        self.persist = false;
        self.curBannerId = null;

        self.showBannerMessage = showBannerMessage;
        self.dismissBannerMessage = dismissBannerMessage;

        $scope.$on('canvas-banner-message-show', onShow);
        $scope.$on('canvas-banner-message-dismiss', onDismiss);

        init();

        self.messages = {};

        ////////////////////////

        function init() {
            logService.log('canvasBannerCtrl init');
        }

        function onShow(evt, msgObj) {
            self.showBannerMessage(msgObj);
        }

        function onDismiss() {
            //Pass true param if dismissed from event (as opposed to user click)
            self.dismissBannerMessage(true);
        }

        function showBannerMessage(msgObj) {
            self.header = msgObj.header;
            self.content = msgObj.content;
            self.state = 'show';
            self.persist = msgObj.persist ? true : false;

            if (msgObj.id) {
                self.curBannerId = msgObj.id;
            } else if (self.curBannerId) {
                self.curBannerId = null;
            }

            digest();
        }

        function dismissBannerMessage(dismissedFromEvent) {
            if (self.state === 'hide') {
                return;
            }

            self.header = '';
            self.content = '';
            self.state = 'hide';
            self.persist = false;

            if (!dismissedFromEvent && self.curBannerId === 'awv-banner') {
                logService.log('Saving AWV banner dimsissal in local storage');
                storageService.set(
                    'awv-banner-dismissed',
                    JSON.stringify({ meetingCode: meetingService.getMeetingCode() })
                );
            }
            self.curBannerId = null;

            digest();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
